import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()
export class ContactProvider {
  private url: string = "contacts";

  constructor(public api: Api) {}

  post(email: string, contact: string, phone: string, contactCategory: string): Observable<any> {
    return this.api.post(this.url, {
      email: email,
      content: contact,
      phone: phone,
      contact_category: contactCategory,
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/contact/contact.ts